export { AntisocialPage as default } from '@/components/enpages/Ir/Governance/Antisocial'
